
var uploads = {

    listen: function () {
        var self = this;
        
        // Start dropzone
        self.initDropzone();

        // Delete file button
        $(".upload-card").on("click", "a.delete-upload" ,function(event) {
            self.handleDeleteUpload(event, $(this));
        });

    },


    initDropzone: function () {
        window.Dropzone.autoDiscover = false;

        $(".dropzone").each(function() {

            var $uploadForm = $(this);

            var driverMode = $uploadForm.hasClass("driver-dropzone");

            var dropzoneOptions = {
                url: $uploadForm.action,
                init: function () {
                    this.on("success", function (file) {

                        var $uploadCard = $uploadForm.closest(".upload-card");
                        var $jobFileEl = $(".jobFiles", $uploadCard);
    
                        // Replace the uploaded files list with the amended one
                        $.get($jobFileEl.data("reloadaction"), function (response) {
                            $jobFileEl.replaceWith(response.markup);
                        }, "json");
    
                    }); 
                }
            }

            if (driverMode) {
                // On phones so change the message
                dropzoneOptions.dictDefaultMessage = "Click here to upload";
            }


            // Initialise the dropzone
            new window.Dropzone($uploadForm[0], dropzoneOptions);

        });
        
    },

    handleDeleteUpload: function (event, element) { 
        event.preventDefault();

        var accepted = confirm("Are you sure you want to remove this file?");

        if (accepted) {
            var action = element.data("action");
            var uploadLine = element.closest(".upload-line");
            
            element.remove(); // Hide trash can
            $.post(action, [], function (response) {
                uploadLine.remove(); 
                
            }, "json");
        }
        
    },



}

$(function () {
    uploads.listen()
});

module.exports = {
    uploads
};